export function parseJson(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return json;
    }
}

export function metadataToTemplate(keysArray, valuesArray) {
    if (!arrayHasDups(keysArray)) {
        if (Array.isArray(keysArray) && Array.isArray(valuesArray)) {
            const json = keysArray.reduce((acc, elem, index) => {
                if (!acc[elem]) {
                    acc[elem] = valuesArray[index];
                }
                return acc;
            }, {});
            return JSON.stringify(json);
        }
    }
}

export function arrayHasDups(array) {
    return Array.isArray(array) && new Set(array).size !== array.length;
}
